// @flow

export const getAnalyticsMetadata = () => {
  const { dataLayer } = window;
  const googleAnalyticsLoadEvent =
    (dataLayer && dataLayer.find((event) => Boolean(event.cid))) || {};

  return {
    gaClientId: googleAnalyticsLoadEvent.cid,
  };
};
